<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formAdvanceInvoiceFirst">
        <div class="ps-2 pe-2">
          <div class="row">
            <div class="col d-flex justify-content-between align-items-center">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" routerLink="/advance-invoice" [severity]="null"></app-custom-button>
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <hr class="my-1">
          </div>
        </div>
        <div class="ps-2 pe-2">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="advanceInvoiceContract.userNameCreate"
                [createDate]="advanceInvoiceContract.createDate"
                [userNameUpdate]="advanceInvoiceContract.userNameUpdate"
                [updateDate]="advanceInvoiceContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row mt-1 d-flex justify-content-between">
            <div class="row">
              <div class="col field-branch">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                  [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
              </div>
              <div class="col field-enterprise">
                <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                  [recovery]="true" (onChangeSelect)="getEnterprise($event, true)"></app-custom-select>
              </div>
              <div class="col field-bussiness-documents-type">
                <app-custom-select formControlName="bussinessDocumentsTypeId" [labelText]="'Tipo'"
                  [list]="listBussinessDocumentsTypes" [recovery]="true"
                  (onChangeSelect)="getBussinessDocumentsType($event, true)"></app-custom-select>
              </div>
              <div class="col field-invoice-consecutive">
                <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [recovery]="true"
                  (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
              </div>
              <div class="col field-string-state">
                <app-custom-tag [label]="'Estado'" [severity]="severityState"
                  [value]="advanceInvoiceStateString"></app-custom-tag>
              </div>
              <div class="col field-button-state d-flex align-items-end">
                <app-custom-button [title]="titleStateAdvanceInvoice" [icon]="iconStateAdvanceInvoice"
                  (onClick)="changeStateAdvanceInvoice()"></app-custom-button>
              </div>
            </div>
            <div class="row">
              <div class="col field-date-invoice">
                <app-custom-datepicker formControlName="dateInvoice" [labelText]="'Fecha'"></app-custom-datepicker>
              </div>
              <div class="col field-client">
                <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                  [class]="getClass('client')"></app-custom-autocomplete>
              </div>
              <div class="col field-cost-center">
                <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'"
                  [list]="filteredCostCenters" [class]="getClass('costCenter')"></app-custom-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col field-zone">
                <app-custom-autocomplete formControlName="zoneId" [labelText]="'Zona'"
                  [list]="listZones"></app-custom-autocomplete>
              </div>
              <div class="col field-seller">
                <app-custom-autocomplete class="custom-field" formControlName="sellerId" [labelText]="'Vendedor'"
                  [list]="listSellers"></app-custom-autocomplete>
              </div>
              <div class="col field-document-type">
                <app-custom-tag [label]="''" [value]="bussinessDocumentsTypeIsRental"></app-custom-tag>
              </div>
              <div class="col field-invoice-difference d-flex align-items-end">
                <app-custom-checkbox class="mb-1 ms-2" formControlName="swInvoiceDifference"
                  [labelText]="'Facturó Diferencia'"></app-custom-checkbox>
              </div>
              <div class="col field-cutoff d-flex align-items-end mt-2 mb-1">
                <app-custom-chip [label]="'Corte Liq.: ' + invoicingCutoffCode" />
              </div>
            </div>
          </div>
        </div>
      </form>
      <div>
        <p-accordion value="none" class="accordion-detail" [transitionOptions]="'0ms'" (onClose)="toggleAccordion()"
          (onOpen)="toggleAccordion()">
          <p-accordion-panel value="0">
            <p-accordion-header>
              <div class="d-flex align-items-center gap-2 w-100">
                <span class="flex-grow-1"> Conceptos Factura Anticipada ({{quantityDetails}}) </span>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <div class="row detail-container container-detail" [hidden]="advanceInvoiceContract.invoiceId == 0"
                *ngIf="showAccordion">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <app-advance-invoice-concept [advanceInvoiceModel]="advanceInvoiceContract" [disabled]="disabledForm"
                    [isFormView]="isFormView" (updateAdvanceInvoice)="getUpdateAdvanceInvoice($event)">
                  </app-advance-invoice-concept>
                </div>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
        <form class="needs-validation mt-2 container-style" [formGroup]="formAdvanceInvoiceFooter">
          <div class="col-lg-12 col-12">
            <div class="row my-1 mx-2 d-flex justify-content-end">
              <div class="col-lg-7 col-12">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="subtotalValue"
                      [labelText]="'Subtotal'"></app-custom-input-decimal>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="discountValue"
                      [labelText]="'Dcto Gral.'"></app-custom-input-decimal>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="ivaValue"
                      [labelText]="'Vr.IVA'"></app-custom-input-decimal>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                    <app-custom-input-decimal formControlName="totalValue"
                      [labelText]="'Total'"></app-custom-input-decimal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>